export enum OpportunityStatus {
    INFORCE = "Inforce",
    FILE_CLOSED = "File Closed"
}
